import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getHost } from './config';
import { grantAnalyticsConsent } from './analytics';
import TermsAcceptanceModal from './TermsAcceptanceModal';

const PUBLIC_PATHS = new Set([
  '/',
  '/register',
  '/terms-of-use',
  '/privacy-policy',
  '/predict-methodology',
  '/forgot-username',
  '/forgot-password',
  '/reset-password',
]);

export default function TermsAcceptanceGate({ children }) {
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [checked, setChecked] = useState(false);

  const checkTermsStatus = useCallback(async () => {
    const token = localStorage.getItem('authToken');
    if (!token || PUBLIC_PATHS.has(location.pathname)) {
      setShowModal(false);
      setChecked(true);
      return;
    }

    setChecked(false);
    try {
      const response = await fetch(`${getHost()}/api/terms-status`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 401) {
        setShowModal(false);
        setChecked(true);
        return;
      }

      if (!response.ok) {
        setShowModal(false);
        setChecked(true);
        return;
      }

      const data = await response.json();
      setShowModal(Boolean(data.needs_terms_acceptance));
      if (!data.needs_terms_acceptance) {
        grantAnalyticsConsent();
      }
    } catch {
      setShowModal(false);
    } finally {
      setChecked(true);
    }
  }, [location.pathname]);

  useEffect(() => {
    checkTermsStatus();
  }, [checkTermsStatus]);

  const handleAccepted = () => {
    setShowModal(false);
    if (localStorage.getItem('pendingWelcomeModal') === 'true') {
      localStorage.setItem('showWelcomeModal', 'true');
      localStorage.removeItem('pendingWelcomeModal');
      window.dispatchEvent(new CustomEvent('terms-accepted-show-welcome'));
    }
  };

  if (!checked && !PUBLIC_PATHS.has(location.pathname) && localStorage.getItem('authToken')) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      {children}
      <TermsAcceptanceModal show={showModal} onAccepted={handleAccepted} />
    </>
  );
}
